function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import _get from 'lodash/get';
import React from 'react';
import localStorage from 'store';
import { Auth } from 'aws-amplify';
import { push, replace } from 'connected-react-router';
import { history } from 'js/store';
import { postCosmosApiData } from 'js/helpers/apiData';
import { AUTH_ROUTE_PATH } from 'js/constants/routes';
import { show } from 'js/store/actions/modal';
import { localizedText } from 'js/localization';
import { AUTH_FORM_SUBMITTING, AUTH_FORM_SUBMITTING_DONE, AUTH_FORM_SUCCESS_MESSAGE, AUTH_FORM_ERROR_MESSAGE } from '../reducers/auth/auth';
var SET_PASSWORD_SUCCESS_MESSAGE = localizedText.SET_PASSWORD_SUCCESS_MESSAGE,
    SET_PASSWORD_ERROR_MESSAGE = localizedText.SET_PASSWORD_ERROR_MESSAGE,
    LOGIN_ERROR_MESSAGE = localizedText.LOGIN_ERROR_MESSAGE;
export var IS_LOGGED_IN = 'isLoggedIn';

var redirect = function redirect(dispatch, role, active) {
  switch (role) {
    case 'freeTrialCustomer':
      if (active === 'true') {
        dispatch(push('/search'));
      } else dispatch(push('/choose-plan'));

      break;

    case 'normalCustomer':
      if (active === 'true') {
        dispatch(push('/search'));
      } else dispatch(push('/choose-plan'));

      break;

    case 'premiumCustomer':
      if (active === 'true') {
        dispatch(push('/search'));
      } else dispatch(push('/choose-plan'));

      break;

    case 'noRole':
      dispatch(replace('/choose-plan'));
      break;

    default:
      // eslint-disable-next-line no-console
      console.log('no route');
      break;
  }
}; // HELPER FUNCTIONS


var handleError = function handleError(error, dispatch, form, defaultErrMsg) {
  var apiErrorMessage = _get(error, 'responseJSON.status_text');

  dispatch({
    type: AUTH_FORM_ERROR_MESSAGE,
    payload: {
      form: form,
      errorMessage: {
        text: apiErrorMessage || defaultErrMsg
      }
    }
  });
  dispatch({
    type: AUTH_FORM_SUBMITTING_DONE,
    payload: {
      form: form
    }
  });
};

var handleAlert = function handleAlert(dispatch, form, defaultAlertMsg) {
  dispatch({
    type: AUTH_FORM_SUCCESS_MESSAGE,
    payload: {
      form: form,
      successMessage: {
        text: defaultAlertMsg
      }
    }
  });
};

var dispatchAuthForm = function dispatchAuthForm(dispatch, type, form) {
  dispatch({
    type: type,
    payload: {
      form: form
    }
  });
}; // SIGN UP


export function signup(formValues) {
  return function (dispatch) {
    dispatchAuthForm(dispatch, AUTH_FORM_SUBMITTING, 'signup');
    var email = formValues.email,
        password = formValues.password,
        first_name = formValues.first_name,
        last_name = formValues.last_name,
        institution_name = formValues.institution_name,
        institution_type = formValues.institution_type,
        choose_plan = formValues.choose_plan,
        country = formValues.country;
    var active = choose_plan === 'freeTrialCustomer' ? 'true' : 'false';
    return Auth.signUp({
      username: email,
      password: password,
      attributes: {
        'custom:first_name': first_name,
        'custom:last_name': last_name,
        'custom:institution_name': institution_name,
        'custom:country': country,
        'custom:institution_type': institution_type,
        'custom:initialRole': choose_plan,
        'custom:active': active
      }
    }).then(handleAlert(dispatch, 'signup', "Comfirmation code sent!")).catch(function (err) {
      handleError(err, dispatch, 'signup', err.message);
    });
  };
} // CONFIRM ACCOUNT

export function confirmAccount(_ref) {
  var email = _ref.email,
      code = _ref.code;
  return function (dispatch) {
    Auth.confirmSignUp(email, code, {
      forceAliasCreation: true
    }).then(function () {
      return history.push('/login');
    }).catch(function (err) {
      if (err.code == 'CodeMismatchException') handleError(err, dispatch, 'requestResetPassword', 'Code mismatch!');
    });
  };
} // SIGN UP PREMIUM TRIAL

export function signupPremiumTrial(formValues) {
  return function (dispatch) {
    dispatchAuthForm(dispatch, AUTH_FORM_SUBMITTING, 'signup');
    return postCosmosApiData('/trials/premium', undefined, formValues).then(function (result) {
      dispatchAuthForm(dispatch, AUTH_FORM_SUBMITTING_DONE, 'signup');
      localStorage.set('userRoles', result.roles);
      show('PremiumModal', {
        content: {
          title: 'Your free COSMOS Premium trial has started.'
        }
      });
    }).catch(function (err) {
      if (err.code == 'InvalidPasswordException') handleError(err, dispatch, 'signup', 'Invalid password format!');
      if (err.code == 'UserNotFoundException') handleError(err, dispatch, 'signup', 'User not found!');
    });
  };
} // SET PASSWORD

export function setPassword(_ref2) {
  var email = _ref2.email,
      code = _ref2.code;
  return function (dispatch) {
    dispatchAuthForm(dispatch, AUTH_FORM_SUBMITTING, 'setPassword');
    return Auth.confirmSignUp(email, code).then(function () {
      dispatchAuthForm(dispatch, AUTH_FORM_SUBMITTING_DONE, 'setPassword');
      history.push("".concat(AUTH_ROUTE_PATH, "?successMessage=").concat(SET_PASSWORD_SUCCESS_MESSAGE));
    }).catch(function (err) {
      handleError(err, dispatch, 'setPassword', SET_PASSWORD_ERROR_MESSAGE);
    });
  };
} // LOG IN

export function login(_ref3) {
  var email = _ref3.email,
      password = _ref3.password;
  return function (dispatch) {
    dispatchAuthForm(dispatch, AUTH_FORM_SUBMITTING, 'login');
    return Auth.signIn(email, password).then(
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(user) {
        var userRole, initialPlan, active;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userRole = user.signInUserSession.idToken.payload['cognito:groups'];
                initialPlan = user.signInUserSession.idToken.payload['custom:initialRole'];
                active = user.signInUserSession.idToken.payload['custom:active']; // eslint-disable-next-line no-console

                console.log('♥');

                if (!(initialPlan && userRole === undefined)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", redirect(dispatch, initialPlan, active));

              case 6:
                return _context.abrupt("return", redirect(dispatch, userRole[0], active));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }()).catch(function (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      if (err.code == 'NotAuthorizedException') return handleError(err, dispatch, 'login', err.message);
      handleError(err, dispatch, 'login', LOGIN_ERROR_MESSAGE);
    });
  };
} // REQUEST RESET PASSWORD

export function requestResetPassword(_ref5) {
  var email = _ref5.email;
  return function (dispatch) {
    Auth.forgotPassword(email).then(function (data) {
      handleAlert(dispatch, 'requestResetPassword', "Code sent!");
    }).catch(function (err) {
      if (err.code == 'LimitExceededException') handleError(err, dispatch, 'requestResetPassword', 'Limit exceeded, please try again later!');
      if (err.code == 'UserNotFoundException') handleError(err, dispatch, 'requestResetPassword', 'User not found!');
    });
  };
} // RESET PASSWORD

export function resetPassword(_ref6) {
  var email = _ref6.email,
      code = _ref6.code,
      new_password = _ref6.new_password;
  return function (dispatch) {
    Auth.forgotPasswordSubmit(email, code, new_password).then(function () {
      handleAlert(dispatch, 'requestResetPassword', "Success!");
      history.push('/login');
    }).catch(function (err) {
      if (err.code == 'CodeMismatchException') handleError(err, dispatch, 'requestResetPassword', 'Code mismatch!');
    });
  };
} // REQUEST RESET PASSWORD

export function sendQuoteRequest(userInfo) {
  return function (dispatch) {
    return postCosmosApiData('/quotes', undefined, userInfo).then(function () {
      dispatch(show('PremiumModal', {
        content: {
          title: React.createElement("h1", null, "We will contact you ASAP, thank you!")
        }
      }));
    }).catch(function () {
      dispatch(show('PremiumModal', {
        content: {
          title: React.createElement("h1", null, "Something went wrong, please try again.")
        }
      }));
    });
  };
} // LOGOUT

export function logout(argument) {
  var pathname = '/login';
  if (argument) pathname = "/login".concat(argument);
  Auth.signOut().then(function () {
    history.push(pathname);
  }).catch(function () {
    history.push(pathname);
  });
}